import { all, fork } from 'redux-saga/effects'

import changeActivitySaga from './changeActivitySaga'

export default function* differentActivitiesSaga() {
  yield all([fork(changeActivitySaga)])
}
